import React from "react";
import RoundButton from "features/shared/components/buttons/RoundButton";
import ExportDefinitionSimplifiedDTO from "features/exports/dtos/ExportDefinitionSimplifiedDTO";
import { useExport } from "features/exports/hooks/useExport";

type Props = {
  exportDef: ExportDefinitionSimplifiedDTO;
};

const ExportDownload = ({ exportDef }: Props) => {
  const { exportHandler } = useExport({});

  const exportDownloadHandler = () => {
    if (exportDef?.exportDefinitionId && exportDef?.exportParams) {
      exportHandler(exportDef.exportDefinitionId, exportDef.exportParams);
    }
  };

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        {exportDef.name}
      </div>
      <div className="col-auto pl-3">
        <RoundButton
          icon="download"
          onClickHandler={exportDownloadHandler}
        />
      </div>
    </div>
  );
};

export default ExportDownload;